import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import AccommodationTextList from './AccommodationTextList'

type Props = {
  packageInclusions: Array<string>
}

function AccommodationPackageInclusions({ packageInclusions }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'hnQFxuD7xgWuh7cb4MwJ',
    defaultMessage: 'Inclusions valid for, based on package purchased',
  })

  return (
    <>
      <BodyText variant="medium" weight="bold" as="h4">{heading}</BodyText>
      <AccommodationTextList items={packageInclusions} />
    </>
  )
}

export default AccommodationPackageInclusions
